<template>
  <v-card flat>
    <!-- <form @submit.prevent="update" @keydown="form.onKeydown($event)"> -->
    <v-card-title primary-title>
      <h5 class="display-1 mb-0">Leistungen auf Ihrem Betriebsprofil</h5>
    </v-card-title>
    <v-card-text v-if="betrieb.leistungenjson < 1">Noch keine Leistung auf Ihrem Profil angezeigt...</v-card-text>
    <v-card-text>

 <div class="mx-2 mb-4">
   <h3 class="headline mt-0 mb-2">Angezeigte Leistungen</h3>
    <p class="subheading mt-3"> 
        Hier können Sie bis zu 6 Leistungen mitsamt Überschrift und Bild für die Anzeige auf Ihrem Profil einstellen. Bitte vergessen Sie nicht, nach den Änderungen zu Speichern!
     <br>Sie können die Reihenfolge der Leistungen durch Ziehen ändern.</p>
        <v-btn large @click="add" v-if="betrieb.leistungenjson.length < 6">
           <v-icon left>add</v-icon>
           Neue Leistung hinzufügen ({{ betrieb.leistungenjson.length }}/6)</v-btn>

            <span v-show="saveready">
          <v-slide-y-transition>
            <v-btn @click="saveForm()"  large color="accent"><v-icon left>save</v-icon> Speichern</v-btn>
          </v-slide-y-transition>
        </span>
        
        <!-- <v-btn @click="getMedia()">media</v-btn> -->

        <!-- <div v-if="medialist">

          <vue-json-pretty :data="medialist"></vue-json-pretty>
        </div> -->
       

 </div>
    <draggable tag="v-layout" class="row wrap justify-start">
      <template v-for="(element,i) in list">
        <!-- <LeistungComponent :title="element.title" :text="element.text" :key="i"></LeistungComponent> -->
         <v-flex xs12 md6 lg4 pa-3 class="row-v" :key="i">
          <v-card tile>
            <!-- <v-img :src="src"></v-img> -->
            <v-card-title class="pa-0" width="100%">
                <v-select
                  v-model="element.selected"
                  label="Bild auswählen"
                  :items="medialist"
                  item-text="file_name"
                  item-value="url"
                  clearable
                  class="mx-3 mt-2"
                  prepend-icon="image"
                  v-if="element.e"
                  full-width
                  no-data-text="Noch keine Medien hochgeladen"
                  >
                  <template slot="item" slot-scope="data">
                      <v-list-tile-avatar tile>
                        <img :src="data.item.url" :alt="data.item.file_name" />
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ data.item.file_name }}
                        </v-list-tile-title>
                      
                      </v-list-tile-content>
                    </template>
                </v-select>

               
                <div v-else style="width: 100%;">
                  
                  <v-img
                  :src="element.selected"
                  width="100%"
                  height="300px"
                  v-if="element.selected"
                  >
                  </v-img>
                </div>

            </v-card-title>
            <v-card-title>
              <v-text-field 
                  v-if="element.e"
                  label="Überschrift"
                  v-model="element.title"
                  counter="60"
                ></v-text-field>
                <div v-else class="headline">{{ element.title}}</div>
            </v-card-title>


            <v-card-text class="py-0"> 
               <v-textarea
                  v-if="element.e"
                  label="Text"
                  v-model="element.text"
                  counter="400"
                  v-focus 
                ></v-textarea>
                <div v-else>
                  <div v-if="element.text">
                    <nl2br tag="p" :text="element.text"/>
                  </div>
                   <div v-else class="font-weight-regular font-italic">
                     Noch keine Beschreibung vorhanden
                    </div>   
                    
                </div>
             
              
            </v-card-text>
           
              <v-card-actions> 
                <v-btn icon disabled v-if="element.e">
                  <v-icon>open_with</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn flat 
                @click="element.e = true" v-if="!element.e">
                  <v-icon left>edit</v-icon> Ändern
                </v-btn>
                <v-btn flat @click="element.e = false; saveready = true; $emit('update');" v-if="element.e">
                   Fertig
                </v-btn>
              
                <v-btn icon @click="removeAt(i); saveready = true;"  v-if="element.e">
                  <v-icon color="red darken-3">delete</v-icon>
                </v-btn>
              </v-card-actions>
              
          </v-card>
        </v-flex>
      </template>
    </draggable>
    </v-card-text>
 <v-card-text>
     <div class="mx-2">
   <h3 class="headline mb-2">Meine Bilderdatenbank</h3>
     <p class="subheading mt-3"> 

       Die hier hochgeladenen Bildern stehen Ihnen oben zur Verfügung.<br>
        Bitte laden Sie nur Bilder hoch, zu denen Sie die Rechte besitzen oder die freigegeben sind. Als Betreiber Ihres Profils sind Sie selbst dafür verantwortlich.
      </p>

    
  <bild-upload @fileadded="getMedia()"></bild-upload>

  <v-btn icon @click="getMedia()"><v-icon>image</v-icon></v-btn>
<vue-json-pretty :data="medialist">
    </vue-json-pretty>
</div>

        
 <v-layout row class="mt-3">
       <v-flex xs4>
        &nbsp;
       </v-flex>
       <v-flex xs4 class="text-xs-center">
        <span v-show="saveready">
          <v-slide-y-transition>
            <v-btn @click="saveForm()"  large color="accent"><v-icon left>save</v-icon> Speichern</v-btn>
          </v-slide-y-transition>
        </span>
       </v-flex>
       <v-flex xs4 class="text-xs-right">
          <v-btn @click="nexttab()" large>Weiter <v-icon right>chevron_right</v-icon></v-btn>
       </v-flex>
    </v-layout>
     </v-card-text>
   <!-- {{ list }} -->
  </v-card>
</template>

<script>
let id = 3
// import Form from "vform";
import axios from 'axios'
import draggable from 'vuedraggable'
import BildUpload from '~/components/meinbetrieb/BildUpload.vue'

export default {
  props: {
    leistungen: Array,
    betrieb: ''
  },
  components: {
    draggable,
    BildUpload
  },
  name: 'leistung-view',

  // mounted () {
  //   const app = this
  //   // var LeistungenListe
  //   axios.get('/api/v1/meineleistung')
  //     .then(function (resp) {
  //       app.company = resp.data

  //       // LeistungenListe = app.company
  //     })
  //     .catch(function () {
  //       // alert("Konnte Firma nicht laden")
  //     })
  // },
  data () {
    return {
      ex7: false,
      medialist: [],
      selected: null,
      e7: [],
      list: [],
      editedLeistung: null,
      message: 'yolo!',
      enabled: true,
      dragging: false,
      saveready: false,
      idstart: 0
    }
  },
  mounted () {
    this.getMedia()
    this.PopulateMedia()
  },
  computed: {
    draggingInfo () {
      return this.dragging ? 'under drag' : ''
    }
  },
  methods: {
    consolelog (value) {
      console.log(value)
    },
    removeAt (idx) {
      this.list.splice(idx, 1)
    },
    add: function () {
      id++
      this.betrieb.leistungenjson.push({ title: 'Leistung ' + id, id, text: '', e: true })
     // this.list.push({ title: 'Leistung ' + id, id, text: '', e: true })
    },
    checkMove: function (e) {
      window.console.log('nächster index: ' + e.draggedContext.futureIndex)
    },
    editLeistung: function (leistung) {
      this.editedLeistung = leistung
    },
    getMedia () {
      axios.get('/api/v1/getmedialibrary')
        .then((resp) => {
         // console.log(resp)
          this.medialist = resp.data
          console.log(this.medialist)
        })
    },
    PopulateMedia () {
      if (this.betrieb.leistungenjson) {
        this.list = this.betrieb.leistungenjson
        this.list.forEach((element) => {
          element.e = false
          element.id = this.idstart++
          if (!element.title) {
            element.title = 'Leistung ' + this.idstart
          }
          // if (!element.leistung) {
          //   element.leistung = 'test'
          // }
        })
        // console.log(typeof this.list)
      }
    },
    nexttab (event) {
      this.$emit('tabswitch')
    },
    saveForm () {
      var app = this
      var newCompany = app.betrieb
      newCompany.leistungenjson = app.list

      axios.patch('/api/v1/companies/' + app.betrieb.id, newCompany)
      .then((resp) => {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('betrieb_updated')
        })
        app.saveready = false
        // app.$router.replace('/meinbetrieb')
      })
      .catch((resp) => {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: this.$t('error_alert_text')
        })
      })
    }
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>

<style scoped>
.button {
  margin-top: 35px;
}
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}
input {
  display: inline-block;
  width: 50%;
}
.text {
  margin: 20px;
}
</style>

